import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'How do I receive the pack after purchasing?',
  answer: 'You will receive immediate access to all the material so you can start using it right away—no waiting, no complicated steps.'
}, {
  question: 'What level of ballet teacher is this for?',
  answer: 'Ballet Teacher Ready™ is designed for ballet teachers at any stage—whether you are just beginning your teaching career or you have been teaching for years. The material is organized so you can use exactly what you need, when you need it.'
}, {
  question: 'Does this work for ballet teachers in any country?',
  answer: 'Yes. The material is fully digital and delivered immediately after purchase. It works for any ballet teacher, in any country, teaching in any context—studio, school, private, or online.'
}, {
  question: 'Can I edit the material?',
  answer: 'The material is designed to be used as-is—ready to open and teach. Everything is structured so you do not need to rewrite or adapt anything before using it in a real class.'
}, {
  question: 'What currency will I pay in?',
  answer: 'The price adapts automatically based on the country you are purchasing from. You will pay in your local currency.'
}, {
  question: 'What if it is not useful for me?',
  answer: 'If within 7 days you feel the material does not meet your teaching needs, contact us and we will refund 100% of your money. No questions asked.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-y border-ballet-line bg-ballet-blush/45 px-4 py-20 sm:py-28" data-id="element-84">
      <div className="mx-auto max-w-3xl" data-id="element-85">
        <div className="text-center" data-id="element-86">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-ballet-rose" data-id="element-87">
            Everything you need to know
          </p>
          <h2 className="mt-3 font-display text-5xl font-semibold text-ballet-ink" data-id="element-88">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="mt-12 space-y-3" data-id="element-89">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-ballet-line bg-white" data-id="element-90">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-ballet-pink/30" data-id="element-91">
                  <span className="text-base font-semibold text-ballet-ink" data-id="element-92">
                    {faq.question}
                  </span>
                  <ChevronDownIcon size={20} className={`shrink-0 text-ballet-gold transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-93" />
                </button>
                <AnimatePresence initial={false} data-id="element-94">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22
              }} data-id="element-95">
                      <p className="border-t border-ballet-line px-6 py-5 text-sm leading-6 text-ballet-muted" data-id="element-96">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}